module.exports = __webpack_public_path__ + "static/media/korien-nosto.6c179db7.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/korien-nosto.mp4
 ** module id = 456
 ** module chunks = 0
 **/